import './ccf-reload-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfReloadIconProps extends SvgIconProps {}
/**
 * This icon will be used to display unavailable status of agent
 * @param props - CcfHelpIcon
 * @example - <CcfHelpIcon />
 * @returns SVG of unavailable icon
 */
export function CcfReloadIcon(props: CcfReloadIconProps) {
  return (
    <SvgIcon {...props}>
     <path d="M18.7 6.63317H14.5C14 6.63317 13.7 6.23116 13.7 5.72864C13.7 5.22613 14.1 4.82412 14.5 4.92462H16.2C14.7 3.11558 12.5 1.90955 10 1.90955C5.6 1.90955 2 5.52764 2 9.94975C2 14.3719 5.6 17.9899 10 17.9899C14.4 17.9899 18 14.3719 18 9.94975H20C20 15.4774 15.5 20 10 20C4.5 20 0 15.5779 0 10.0503C0 4.52261 4.5 0 10 0C13.2 0 16 1.50754 17.9 3.9196V1.60804C17.9 1.10553 18.3 0.703518 18.7 0.80402C19.1 0.80402 19.5 1.10553 19.5 1.60804V5.92965C19.5 6.33166 19.1 6.73367 18.7 6.63317Z" fill="#fff"/>
    </SvgIcon>
  );
}

export default CcfReloadIcon;
